import { loadCSS, loadJS } from 'javascripts/globals/loaders';

function throttle(callback, time = 100) {
  let wait = false;

  return function trigger(e) {
    if (wait) return;

    callback(e);

    wait = true;
    setTimeout(() => {
      wait = false;
    }, time);
  };
}

const COLORS = {
  LINE: '#fff',
  DEFAULT: '#bababa',
  ACTIVE: '#0a8983',
  DISABLED: '#f2f2f2',
};

export default class ContactPersons {
  constructor($el) {
    this.$continentSelect = $el.querySelector('select[data-contact-persons-continent]');
    this.$countrySelect = $el.querySelector('select[data-contact-persons-country]');
    this.$submit = $el.querySelector('button[data-contact-persons-submit]');

    this.$box = $el.querySelector('[data-contact-persons-box]');
    this.$close = $el.querySelector('[data-contact-persons-close]');
    this.$items = $el.querySelector('[data-contact-persons-items]');
    this.$empty = $el.querySelector('[data-contact-persons-empty]');
    this.emptyBoxClass = 'contact-persons__items-box--empty';

    this.$map = $el.querySelector('[data-contact-persons-map]');
    this.$back = $el.querySelector('[data-contact-persons-back]');

    this.allItems = JSON.parse($el.getAttribute('data-contact-persons'));
    this.generalItems = this.allItems.filter(item => item.general === true);
    this.lastCountryCode = '';

    this.getItemTemplate($el);

    this.bindEvents();

    this.loadMap();
  }

  getItemTemplate($el) {
    const $tplContainer = $el.querySelector('script[data-contact-persons-tpl]');
    const tmpTag = $tplContainer.getAttribute('data-contact-persons-tpl');
    const $tmp = document.createElement(tmpTag);
    $tmp.innerHTML = $tplContainer.innerHTML;

    [this.itemTpl] = $tmp.children;
  }

  loadMap() {
    if (this.$map === null || this.$map.offsetWidth === 0) return;

    const leafletPath = this.$map.getAttribute('data-core-path') || 'https://unpkg.com/leaflet@1.9.3/dist/';

    // // eslint-disable-next-line no-unused-expressions
    // import(/* webpackChunkName: "leaflet" */ 'leaflet/dist/leaflet.css');
    // import(/* webpackChunkName: "leaflet" */ 'leaflet').then(({ default: L }) => {
    //   this.L = L;
    //   this.initMap();
    // });
    // eslint-disable-next-line no-unused-expressions
    loadCSS(`${leafletPath}leaflet.css`, 'leaflet');
    loadJS(`${leafletPath}leaflet.js`, 'leaflet').then(() => {
      this.L = window.L;
      this.initMap();
    });
  }

  initMap() {
    const { L, $map } = this;

    const map = L.map($map, {
      zoom: 10,
      center: [0, 0],
      zoomSnap: 0.1,
      zoomControl: false,
      attributionControl: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
    });
    L.control.zoom({ position: 'topright' }).addTo(map);

    this.map = map;
    this.renderer = map.getRenderer(map);
    this.renderer.options.padding = 0.3;

    this.defaultBounds = L.latLngBounds([
      [82, -170],
      [-54, 170],
    ]);

    map.fitBounds(this.defaultBounds);
    map.setMinZoom(map.getZoom());
    map.setMaxZoom(12);

    // this.initTiles();
    this.loadGeoJson();
  }

  initTiles() {
    const { L, map } = this;

    this.tileLayer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
  }

  loadGeoJson() {
    const { $map } = this;

    const geoJsonUrl = $map.getAttribute('data-data-url');
    if (geoJsonUrl === null) return;

    fetch(geoJsonUrl)
      .then(res => res.json())
      .then((jsonData) => {
        this.initGeoJson(jsonData);
      });
  }

  initGeoJson(jsonData) {
    const { L, map } = this;

    const onCountryEnter = this.onCountryEnter.bind(this);
    const onCountryLeave = this.onCountryLeave.bind(this);
    const onCountryClick = this.onCountryClick.bind(this);

    const onContinentEnter = this.onContinentEnter.bind(this);
    const onContinentLeave = this.onContinentLeave.bind(this);
    const onContinentClick = this.onContinentClick.bind(this);

    // // to compress - limit decimal places
    // const subst = '$1$2$3';
    // const regex = /(\[-?\d+\.\d{4})\d*?(,-?\d+\.\d{4})\d*?(\])/gm;
    // // eslint-disable-next-line no-param-reassign
    // jsonData = JSON.parse(JSON.stringify(jsonData).replace(regex, subst));

    /**
     * to export new json
     * download custom.geo.json from https://geojson-maps.ash.ms/
     * replace `data-data-url='/media/map.geo.json'`
     * by `data-data-url='/media/custom.geo.json'`
     * in contact-persons.pug
     * uncomment export code in this script
     * */

    const continents = {};
    // to export props only json
    // const propsOnly = [];
    // to export minimized json
    // const geo = L.geoJSON(jsonData, {
    L.geoJSON(jsonData, {
      // style: feature => ({
      //   color: feature.properties.color,
      // }),
      style: {
        color: COLORS.LINE,
        weight: 1,
        fillColor: COLORS.DEFAULT,
        fillOpacity: 1,
      },
      onEachFeature: (feature, layer) => {
        // to compress - remove unused props
        // // eslint-disable-next-line no-param-reassign
        // feature.properties = {
        //   name: feature.properties.name,
        //   continent: feature.properties.continent,
        //   iso_a2_eh: feature.properties.iso_a2_eh,
        // };

        // to create props only array full
        // propsOnly.push(feature.properties);

        // to create props only array
        // propsOnly.push({
        //   name: feature.properties.name,
        //   name_ar: feature.properties.name_ar,
        //   name_bn: feature.properties.name_bn,
        //   name_de: feature.properties.name_de,
        //   name_en: feature.properties.name_en,
        //   name_es: feature.properties.name_es,
        //   name_fa: feature.properties.name_fa,
        //   name_fr: feature.properties.name_fr,
        //   name_el: feature.properties.name_el,
        //   name_he: feature.properties.name_he,
        //   name_hi: feature.properties.name_hi,
        //   name_hu: feature.properties.name_hu,
        //   name_id: feature.properties.name_id,
        //   name_it: feature.properties.name_it,
        //   name_ja: feature.properties.name_ja,
        //   name_ko: feature.properties.name_ko,
        //   name_nl: feature.properties.name_nl,
        //   name_pl: feature.properties.name_pl,
        //   name_pt: feature.properties.name_pt,
        //   name_ru: feature.properties.name_ru,
        //   name_sv: feature.properties.name_sv,
        //   name_tr: feature.properties.name_tr,
        //   name_uk: feature.properties.name_uk,
        //   name_ur: feature.properties.name_ur,
        //   name_vi: feature.properties.name_vi,
        //   name_zh: feature.properties.name_zh,
        //   name_zht: feature.properties.name_zht,
        //   continent: feature.properties.continent,
        //   iso_a2_eh: feature.properties.iso_a2_eh,
        // });

        // // to detect bounds anomalies
        // const tmpGroup = L.featureGroup();
        // layer.addTo(tmpGroup);
        // if (feature.properties.continent === 'Europe') {
        //   // eslint-disable-next-line no-underscore-dangle
        //   if (tmpGroup.getBounds()._southWest.lat < 26) {
        //     console.log(feature.properties.name);
        //   }
        // }

        const { continent } = feature.properties;
        if (continents[continent] === undefined) continents[continent] = L.featureGroup();
        layer.addTo(continents[continent]);

        layer.on('mouseover', onCountryEnter);
        layer.on('mouseout', onCountryLeave);
        layer.on('click', onCountryClick);
      },
    });
    this.continents = continents;

    // to export props only json
    // console.log(JSON.stringify(propsOnly));

    // to export minimized json
    // console.log(JSON.stringify(geo.toGeoJSON()));

    // to get click lat lng
    // this.map.on('click', e => console.log(e));

    this.eachContinent((continent) => {
      continent.addTo(map);
      continent.on('mouseover', onContinentEnter);
      continent.on('mouseout', onContinentLeave);
      continent.on('click', onContinentClick);
    });

    // partial move around the issue https://github.com/Leaflet/Leaflet/issues/2814

    this.map.on('move', throttle((e) => {
      if (!e.flyTo) this.map.fire('moveend');
    }, 300));

    // this.map.on('zoom', throttle(() => {
    //   this.map.fire('viewreset');
    // }, 600));
  }

  eachContinent(callback) {
    const { continents } = this;
    if (continents === undefined) return;

    Object.keys(continents).forEach((continentName) => {
      callback(continents[continentName], continentName);
    });
  }

  skipCountryEvent(e) {
    const continent = this.$continentSelect.value;
    const country = this.$countrySelect.value;

    return (
      continent === ''
      || country !== ''
      || e.target.feature.properties.continent !== continent
    );
  }

  skipContinentEvent(e) {
    const continent = this.$continentSelect.value;

    return (
      continent !== ''
      || e.layer.feature.properties.continent === 'skip'
    );
  }

  onCountryEnter(e) {
    if (this.skipCountryEvent(e)) return;

    e.target.setStyle({
      fillColor: COLORS.ACTIVE,
    });
  }

  onCountryLeave(e) {
    if (this.skipCountryEvent(e)) return;

    e.target.setStyle({
      fillColor: COLORS.DEFAULT,
    });
  }

  onCountryClick(e) {
    if (this.skipCountryEvent(e)) return;

    const country = e.target.feature.properties.iso_a2_eh;
    ContactPersons.setSelectValue(this.$countrySelect, country);
  }

  onContinentEnter(e) {
    if (this.skipContinentEvent(e)) return;

    e.target.setStyle({
      fillColor: COLORS.ACTIVE,
    });
  }

  onContinentLeave(e) {
    if (this.skipContinentEvent(e)) return;

    e.target.setStyle({
      fillColor: COLORS.DEFAULT,
    });
  }

  onContinentClick(e) {
    if (this.skipContinentEvent(e)) return;

    const { continent } = e.layer.feature.properties;
    ContactPersons.setSelectValue(this.$continentSelect, continent);
  }

  bindEvents() {
    this.$continentSelect.addEventListener('change', this.onContinentChange.bind(this));
    this.$countrySelect.addEventListener('change', this.onCountryChange.bind(this));

    if (this.$submit) this.$submit.addEventListener('click', this.onSubmitClick.bind(this));
    this.$back.addEventListener('click', this.onBackClick.bind(this));
    this.$close.addEventListener('click', this.onCloseClick.bind(this));
  }

  onContinentChange() {
    this.updateList();
    this.updateBack();

    if (this.map === undefined) return;

    const activeContinent = this.$continentSelect.value;

    this.eachContinent((continent, continentName) => {
      const isActive = (activeContinent === '' || continentName === activeContinent);

      continent.setStyle({
        fillColor: isActive ? COLORS.DEFAULT : COLORS.DISABLED,
      });

      if (!isActive || activeContinent === '') return;

      this.map.flyToBounds(continent.getBounds(), {
        paddingTopLeft: [20, 20],
        paddingBottomRight: [20, 20],
      });
    });
  }

  onCountryChange() {
    this.updateList();
    this.updateBack();

    if (this.map === undefined) return;

    const activeContinent = this.$continentSelect.value;
    const activeCountry = this.$countrySelect.value;

    if (activeContinent === '' || activeCountry === '') return;

    this.eachContinent((continent, continentName) => {
      if (continentName !== activeContinent) return;

      continent.eachLayer((layer) => {
        const country = layer.feature.properties.iso_a2_eh;
        const isActive = (activeCountry === '' || country === activeCountry);

        layer.setStyle({
          fillColor: isActive ? COLORS.ACTIVE : COLORS.DEFAULT,
        });

        if (!isActive || activeCountry === '') return;

        this.map.flyToBounds(layer.getBounds(), {
          paddingTopLeft: [380, 60],
          paddingBottomRight: [60, 60],
        });
      });
    });
  }

  onSubmitClick(e) {
    e.preventDefault();
  }

  onBackClick(e) {
    e.preventDefault();

    this.resetSelection();
  }

  onCloseClick(e) {
    e.preventDefault();

    this.resetSelection();
  }

  resetSelection() {
    ContactPersons.setSelectValue(this.$countrySelect, '');
    ContactPersons.setSelectValue(this.$continentSelect, '');

    this.updateBack();

    if (this.map === undefined) return;

    this.map.flyToBounds(this.defaultBounds);
  }

  updateList() {
    const countryCode = this.$countrySelect.value;
    if (countryCode === this.lastCountryCode) return;

    this.lastCountryCode = countryCode;

    this.$items.innerHTML = '';

    if (countryCode === '') {
      this.$box.classList.add(this.emptyBoxClass);
      this.$items.appendChild(this.$empty);
      return;
    }

    const items = this.getActiveItems(countryCode);

    if (items.length === 0) {
      this.$box.classList.add(this.emptyBoxClass);
      this.$items.appendChild(this.$empty);
      return;
    }

    const $tmpItems = document.createDocumentFragment();
    items.forEach((item) => {
      $tmpItems.appendChild(this.getItemElement(item));
    });

    this.$items.appendChild($tmpItems);
    this.$box.classList.remove(this.emptyBoxClass);
  }

  getActiveItems(countryCode) {
    const items = this.allItems.filter(item => item.countries.includes(countryCode));
    if (items.length > 0) return items;

    return this.generalItems;
  }

  getItemElement({
    title, text, address, meta,
  }) {
    const $item = this.itemTpl.cloneNode(true);

    const $title = $item.querySelector('.headline__text');
    if ($title !== null) $title.innerHTML = title;

    const $text = $item.querySelector('.contact-person__text');
    if ($text !== null) $text.innerHTML = text;

    const $address = $item.querySelector('.contact-person__address');
    if ($address !== null) $address.innerHTML = address;

    const $meta = $item.querySelector('.contact-person__meta');
    if ($meta !== null) $meta.innerHTML = meta;

    return $item;
  }

  updateBack() {
    const { $back, $continentSelect } = this;

    const isBackActive = $continentSelect.value !== '';

    ContactPersons.setDisabled($back, !isBackActive);
  }

  static setSelectValue($select, value = '') {
    const hasOption = Array.from($select.options)
      .findIndex(option => option.value === value) !== -1;
    // eslint-disable-next-line no-param-reassign
    $select.value = hasOption ? value : '';
    $select.dispatchEvent(new Event('change'));
  }

  static setDisabled($el, disabled) {
    if (disabled) {
      $el.setAttribute('disabled', 'disabled');
    } else {
      $el.removeAttribute('disabled');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-contact-persons').forEach(
    $contactPersons => new ContactPersons($contactPersons),
  );
});
